import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { companyProfile } from '@/config/companyProfile'
import { useTranslation } from '@/utils/i18n'
import './MegaMenu.css'

export default function MegaMenu ({ sections = [], onNavigate = () => {}, ctaLabel }) {
  const { t } = useTranslation()
  const [active, setActive] = useState(() => sections?.[0]?.id)
  const activeSection = useMemo(
    () => sections?.find(section => section.id === active) ?? sections?.[0],
    [active, sections]
  )

  if (!sections?.length) {
    return null
  }

  const handleActivate = sectionId => {
    setActive(sectionId)
  }

  return (
    <div className="mega-menu" role="menu">
      <div className="mega-menu-panel">
        <div className="mega-menu-categories" role="tablist" aria-orientation="vertical">
          {sections.map(section => {
            const isActive = activeSection?.id === section.id
            return (
              <button
                key={section.id}
                type="button"
                className={`mega-menu-category ${isActive ? 'is-active' : ''}`}
                onMouseEnter={() => handleActivate(section.id)}
                onFocus={() => handleActivate(section.id)}
                onClick={() => handleActivate(section.id)}
                role="tab"
                aria-selected={isActive}
              >
                <span className="mega-menu-category__label">{section.label}</span>
                {section.description && <small>{section.description}</small>}
              </button>
            )
          })}
        </div>

        <div className="mega-menu-content">
          <div className="mega-menu-links" role="tabpanel">
            {activeSection?.submenu?.map(item => (
              <Link key={`${item.path}::${item.label}`} to={item.path} onClick={onNavigate}>
                <span>{item.label}</span>
                <span className="mega-menu-link__chevron">→</span>
              </Link>
            ))}
          </div>
          <div className="mega-menu-cta">
            <p className="mega-menu-cta__eyebrow">{t('mega.cta.eyebrow', 'Accélérer vos projets')}</p>
            <h4>{t('mega.cta.title', 'Devis en 24h')}</h4>
            <p>{t('mega.cta.description', 'Parlez à un chargé de compte dédié pour dimensionner l’équipe {{companyName}}.', { companyName: companyProfile.name })}</p>
            <Link to="/quote" className="btn-primary" onClick={onNavigate}>
              {ctaLabel ?? t('mega.cta.button', 'Demander un devis')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

MegaMenu.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    submenu: PropTypes.arrayOf(
      PropTypes.shape({
        path: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired
      })
    )
  })),
  onNavigate: PropTypes.func,
  ctaLabel: PropTypes.string
}
